import { render, staticRenderFns } from "./OrganismAlertManagement.vue?vue&type=template&id=427cfe22&scoped=true&"
import script from "./OrganismAlertManagement.vue?vue&type=script&lang=js&"
export * from "./OrganismAlertManagement.vue?vue&type=script&lang=js&"
import style0 from "./OrganismAlertManagement.vue?vue&type=style&index=0&id=427cfe22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427cfe22",
  null
  
)

export default component.exports